import { anodum, contentEditable } from '@yola/ws-sdk';

const { BLOCK_ELEMENTS } = contentEditable.constants.editableElements;

const isFragmentNode = (node) => node.nodeType === Node.DOCUMENT_FRAGMENT_NODE;

function replaceEmptyTextNodesWithNbsp(node) {
  if (
    anodum.isTextNode(node) &&
    !anodum.isNonEmptyTextNode(node) &&
    anodum.isElementNode(node.parentNode)
  ) {
    if (!node.parentNode.closest(BLOCK_ELEMENTS)) return; // Only wrap empty text nodes in block elements

    const nbspNode = document.createTextNode('\u00A0');
    node.parentNode.replaceChild(nbspNode, node);
    return;
  }

  if (anodum.isElementNode(node) || isFragmentNode(node)) {
    node.childNodes.forEach(replaceEmptyTextNodesWithNbsp);
  }
}

export default replaceEmptyTextNodesWithNbsp;
